import { NgModule } from "@angular/core";
import { CustomSectionComponent } from "./custom-section.component";
import { SectionModule } from "@airnauts/ng-components/section";

@NgModule({
  declarations: [CustomSectionComponent],
  imports: [SectionModule],
  exports: [CustomSectionComponent],
})
export class CustomSectionModule {}
